import type IBlogPost from "@api/models/IBlog";
import ButtonVariants from "@core-components/button/ButtonVariants";
import SSHeadline from "@core-components/title/SSHeadline";
import SSWhiteText from "@core-components/title/components/SSWhiteText";
import EPublicRoutes from "@core-types/routes.enum";
import useAppLanguage from "@hooks/language/useAppLanguage";
import { Group } from "@mantine/core";
import AppSkeleton from "@modules/loader/AppSkeleton";
import ReadingTime from "./ReadingTime";
import UpdatedAt from "./UpdatedAt";
import WrittenBy from "./WrittenBy";

interface Props {
  blog?: IBlogPost;
}

const BlogHeader: React.FC<Props> = ({ blog }) => {
  const { locationUrlBuilder } = useAppLanguage();

  return (
    <>
      <ButtonVariants.Back href={locationUrlBuilder(EPublicRoutes.BLOGS)} />

      <AppSkeleton>
        <SSHeadline
          props={{
            title: {
              order: 1,
              size: "h1",
              ff: "unset",
            },
          }}
        >
          <SSWhiteText>{blog?.title ?? ""}</SSWhiteText>
        </SSHeadline>
      </AppSkeleton>

      <Group className="w-full" justify="space-between">
        <UpdatedAt blog={blog} />

        <ReadingTime blog={blog} />

        <WrittenBy blog={blog} />
      </Group>
    </>
  );
};

export default BlogHeader;
